import { VotingsTabsController } from './votings_tabs_controller'

class VotingsController {

  element = null

  constructor() {
    this.element = document.querySelector('[data-input=candidate-votings]')

    this._initializeTabsController()
  }

  _initializeTabsController() {
    const tabsController = new VotingsTabsController(this.element)
  }
}

export { VotingsController }
